import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react";

type Variant = "primary" | "orange" | "ghost";
type Size = "md" | "lg";

interface CommonProps {
  variant?: Variant;
  size?: Size;
  className?: string;
  children: React.ReactNode;
}

type ButtonProps = CommonProps &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "className"> & {
    as?: "button";
  };

type AnchorProps = CommonProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "children" | "className"> & {
    as: "a";
  };

export type Props = ButtonProps | AnchorProps;

function classes(variant: Variant, size: Size, extra?: string) {
  return ["btn", `btn--${variant}`, size === "lg" ? "btn--lg" : "", extra ?? ""]
    .filter(Boolean)
    .join(" ");
}

export function Button(props: Props) {
  const variant = props.variant ?? "primary";
  const size = props.size ?? "md";
  const className = classes(variant, size, props.className);

  if (props.as === "a") {
    const { as: _as, variant: _v, size: _s, className: _c, children, ...rest } = props;
    return (
      <a className={className} {...rest}>
        {children}
      </a>
    );
  }

  const { as: _as, variant: _v, size: _s, className: _c, children, ...rest } = props;
  return (
    <button className={className} type={rest.type ?? "button"} {...rest}>
      {children}
    </button>
  );
}
